import { View } from 'native-base';
import React from 'react';
import { EmptyDot, FilledDot } from '../../constants/imgs';
import { shadow } from '../../helpers/helpers';
import Badge from './Badge';
import Image from './customImg'
import Text from './TextLabel';

const CardOptionComp = ({ selected, data, card = false, backgroundColor = '#fff', color }) => {
    return (
        <View
            // shadow={shadow({ color: '#00000010', radius: 8, offsetWidth: 1, offsetHeight: 1 })}
            backgroundColor={backgroundColor}
            borderWidth={1}
            borderColor={selected && !card ? '#20A2DF' : '#fff'}
            borderRadius={8} paddingX={4}
            paddingY={card ? 2 : 4}
            flexDirection='row'
            justifyContent={'space-between'} alignItems='center' >
            <View maxW={'80%'} flexDirection='row' alignItems={'center'}>
                {
                    card && <Image
                        svg
                        fill='#20A2DF'
                        uri={data?.image}
                        width={25}
                        height={25}
                    />
                }
                <View w={'100%'} >
                    <Text fontFamily='semiBold' style={{ fontSize: 14, color: '#3B3B3B' }}>
                        {data.title}
                    </Text>
                    {
                        data.desc ?
                            <Text style={{ fontSize: 12, color: '#3B3B3B' }}>
                                {data.desc}
                            </Text>
                            : <View />
                    }
                </View>

            </View>
            <View >
                {
                    // card ?
                    //     selected ? <Badge title={'Selected'} color='#cacaca' /> : <View />
                    //     :
                    <Image
                        svg
                        fill='#20A2DF'
                        uri={selected ? FilledDot : EmptyDot}
                        width={15}
                        height={15}
                    />
                }


            </View>

        </View>
    )
}

export default CardOptionComp;